__webpack_require__.p = "/core/assets/ai-chat/";